module.exports = __webpack_public_path__ + "img/FlagNetherlands.baf8c5db.png";